import { Avatar, Card, CopyToClipboard, Text } from "@certn/cascadia-react";
import { css } from "@emotion/css";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { ActionsDropdown } from "./ActionsDropdown";
import { StatusTag } from "./StatusTag";

interface Props {
  name: string | null;
  email: string | null;
  id: string;
  roles: string;
  isActive: boolean;
  refreshUser: () => void;
}
export function TableDataCard(props: Props) {
  const { name, email, id, roles, isActive, refreshUser } = props;
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Card>
      <div
        className={styles.container}
        role="presentation"
        onClick={() => {
          navigate(`/settings/user/${id}`, {
            state: {
              last: { href: `${location.pathname}${location.search}` },
            },
          });
        }}
        data-testid="sm-user-selectable-container"
      >
        <div className={styles.topHalf}>
          <div className={styles.userDetailsContainer}>
            <Avatar name={name || email} />
            <div className={styles.userDetails}>
              <Text style="global/heading-medium" testID="sm-user-name">
                {name || "--"}
              </Text>
              <Text color="text-weak" testID="sm-user-email">
                {email ? (
                  <CopyToClipboard text={email} testID="copyable-email" />
                ) : (
                  "--"
                )}
              </Text>
            </div>
          </div>
          <ActionsDropdown
            id={id}
            name={name || email}
            refreshUser={refreshUser}
            isActive={isActive}
            showViewUser
          />
        </div>
        <div className={styles.bottomHalf}>
          <div className={css(styles.column, { flexBasis: "60%" })}>
            <Text style="global/label-small" color="text-weak">
              {t("Role")}
            </Text>
            <Text>{roles}</Text>
          </div>
          <div className={styles.column}>
            <Text style="global/label-small" color="text-weak">
              {t("Status")}
            </Text>
            <Text>
              <StatusTag isActive={isActive} />
            </Text>
          </div>
        </div>
      </div>
    </Card>
  );
}

const styles = {
  container: css({
    padding: "var(--space-4)",
    display: "flex",
    flexDirection: "column",
    gap: "var(--space-4)",
    borderRadius: "var(--border-radius-3)",
    cursor: "pointer",
  }),
  topHalf: css({
    display: "flex",
    justifyContent: "space-between",
  }),
  userDetailsContainer: css({
    display: "flex",
    alignItems: "center",
    gap: 10,
  }),
  userDetails: css({
    display: "flex",
    flexDirection: "column",
    textAlign: "left",
  }),
  bottomHalf: css({
    display: "flex",
    flexDirection: "row",
    gap: "var(--space-2)",
  }),
  column: css({
    display: "flex",
    flexDirection: "column",
  }),
};
